<template>
	<ellipse cx="10" cy="4" rx="7" ry="2" stroke="currentColor" stroke-width="1.5" />
	<path d="M17 4L15.5 16C15 17.5 12 18 10 18C8 18 5 17.5 4.5 16L3 4" stroke="currentColor" stroke-width="1.5" />
</template>
